export default "__VITE_ASSET__B4I2b6WF__"